export default "__VITE_ASSET__eI2ubT9r__"